import { PresetsActionTypes } from './presets.actions.types'

export const setCurrentPresetIdx = (idx) => ({
    type: PresetsActionTypes.SET_CURRENT_PRESET_IDX,
    payload : {
        idx
    }
})